import { render, staticRenderFns } from "./switch-auto-tips.vue?vue&type=template&id=4e41c901&scoped=true&"
import script from "./switch-auto-tips.vue?vue&type=script&lang=ts&"
export * from "./switch-auto-tips.vue?vue&type=script&lang=ts&"
import style0 from "./switch-auto-tips.vue?vue&type=style&index=0&id=4e41c901&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e41c901",
  null
  
)

export default component.exports